import { Component } from 'react';
import { connect } from 'react-redux';

class Cinitial extends Component {
    render() {
        return null;
    }
}

const mapStateToProps = state => {
    return {
    }
}

const mapDispatchToProps = dispatch => {
    return {
    }
}

export default connect(mapStateToProps,mapDispatchToProps)(Cinitial);



// WEBPACK FOOTER //
// ./src/containers/Cinitial/index.js